import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { CompanyEnabledFeatureKeyType } from 'common/types/server-api-dtos';
import { CommonServiceApiTags } from 'common/services/api-tags';
import { EE, EventsBus } from '../../utils/events-bus';
import { useCustomizationStore } from 'common/services/customizations-service/service-store/service-store';
import { useToastActions } from 'common/services/toast-service/hooks';
import { customizationsServiceIsEnabledFeatureKeySelector } from 'common/services/customizations-service/service-store/selectors';
import { _kc, LOGOUT_ACTION_KEY } from 'common/utils/user-service';
export var EventsListener = function () {
    var t = useTranslation().t;
    var _a = useToastActions(), addErrorToast = _a.addErrorToast, addToast = _a.addToast;
    var isAllowEmployeesToTransferCurrency = useCustomizationStore(customizationsServiceIsEnabledFeatureKeySelector(CompanyEnabledFeatureKeyType.AllowEmployeesToTransferCurrency));
    var queryClient = useQueryClient();
    var LOGOUT_ACTION = localStorage.getItem(LOGOUT_ACTION_KEY);
    var isAllowEmployeesToTransferCurrencyRef = useRef(isAllowEmployeesToTransferCurrency);
    useEffect(function () {
        isAllowEmployeesToTransferCurrencyRef.current = isAllowEmployeesToTransferCurrency;
    }, [isAllowEmployeesToTransferCurrency]);
    useEffect(function () {
        if (LOGOUT_ACTION) {
            localStorage.removeItem(LOGOUT_ACTION_KEY);
            _kc.logout();
        }
    }, [LOGOUT_ACTION]);
    useEffect(function () {
        var updateCustomizationsCb = function () {
            queryClient.invalidateQueries({
                queryKey: [CommonServiceApiTags.Customization],
            });
        };
        var updateProfileCb = function () {
            queryClient.invalidateQueries({
                queryKey: [CommonServiceApiTags.Profile],
            });
        };
        EE.on(EventsBus.editProfile, updateProfileCb);
        EE.on(EventsBus.updateCustomizations, updateCustomizationsCb);
        return function () {
            EE.off(EventsBus.editProfile, updateProfileCb);
            EE.off(EventsBus.updateCustomizations, updateCustomizationsCb);
        };
    }, [queryClient]);
    useEffect(function () {
        var showToastCb = function (_a) {
            var title = _a.title, message = _a.message;
            addErrorToast({ title: title || t('eventsListener.errorToast.titleDef'), message: message });
        };
        var logoutCb = function () {
            addToast({
                title: t('eventsListener.errorToast.unauthorizeTitle'),
                message: t('eventsListener.errorToast.unauthorizeMessage'),
            });
        };
        var tokenExpiredCb = function () {
            addToast({
                title: t('eventsListener.errorToast.tokenExpTitle'),
                message: t('eventsListener.errorToast.tokenExpMessage'),
            });
        };
        EE.on(EventsBus.showMessage, showToastCb);
        EE.on(EventsBus.logout, logoutCb);
        EE.once(EventsBus.tokenExpired, tokenExpiredCb);
        return function () {
            EE.off(EventsBus.showMessage, showToastCb);
            EE.off(EventsBus.logout, logoutCb);
        };
    }, [addErrorToast, addToast, t]);
    return null;
};
